<script>
export default {
  name: 'DateField',
  // v-model
  model: {
    prop: 'date',
    event: 'update',
  },
  props: {
    // Дата (в формате dd.mm.yyyy)
    date: {
      type: String,
      default: '',
    },
    // Правила валидации
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
    // Подпись для поля
    label: {
      type: String,
      default: 'Дата',
    },
  },

  data() {
    return {
      // Состояние меню
      state: false,
      activePicker: null,
      // Дата для пикера (в формате yyyy-mm-dd)
      localDate: null,
    };
  },

  watch: {
    date(newVal) {
      this.localDate = this.fromDateToLocal(newVal);
    },
  },

  methods: {
    // Действия при изменении даты
    saveDate(date) {
      this.$refs.menu.save(date);
      this.$emit('update', this.fromLocalToDate(date));
    },
    // Сконвертировать дату из формата отображения в формат для date-picker
    fromDateToLocal(date) {
      if (!date) return null;
      const [day, month, year] = date.split('.');
      return `${year}-${month}-${day}`;
    },
    // Сконвертировать дату из формата для date-picker в формат отображения
    fromLocalToDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
  },
};
</script>

<template>
  <v-menu
    ref="menu"
    v-model="state"
    :close-on-content-click="false"
    min-width="auto"
    offset-y
    transition="scale-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="date"
        :label="label"
        :rules="rules"
        append-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="localDate"
      :active-picker.sync="activePicker"
      :max="
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10)
      "
      first-day-of-week="1"
      locale="ru-ru"
      min="1950-01-01"
      @change="saveDate"
    />
  </v-menu>
</template>

<style lang="scss" scoped></style>
